import { render, staticRenderFns } from "./SidebarItemExact.vue?vue&type=template&id=51fbd748&scoped=true&"
import script from "./SidebarItemExact.vue?vue&type=script&lang=js&"
export * from "./SidebarItemExact.vue?vue&type=script&lang=js&"
import style0 from "./SidebarItemExact.vue?vue&type=style&index=0&id=51fbd748&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fbd748",
  null
  
)

export default component.exports